export function generatePainFile(items, endpoint, setError) {
  let result = [];
  for (var i = 0; i < items.length; i++) {
    result.push(items[i].Id);
  }
  var token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
  var req = new XMLHttpRequest();
  req.open("POST", "/api/admin" + endpoint, true);
  req.setRequestHeader("Authorization", "Bearer " + token);
  req.setRequestHeader("Content-Type", "application/json");

  req.onload = () => {
    var data = req.response;
    var response;
    if (req.status !== 200) {
      if (req.status === 404) response = "404 Not Found";
      else response = JSON.parse(req.response.toString())["Message"] || "";
      setError(response);
      return;
    }
    var fileName = "Pain.xml";
    var file = new Blob([data], { type: "application/xml" });
    if (
      window.navigator.msSaveOrOpenBlob // IE10+
    )
      window.navigator.msSaveOrOpenBlob(file, fileName);
    else {
      // Others
      var link = document.createElement("a"),
        url = URL.createObjectURL(file);
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 0);
    }
  };
  req.send(JSON.stringify(result));
  setError("");
}
export function generatePainFileWithCurrency(
  items,
  currency,
  endpoint,
  setError,
) {
  let result = items.map((x) => x.Id);
  let token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
  let req = new XMLHttpRequest();
  req.open("POST", "/api/admin" + endpoint, true);
  req.setRequestHeader("Authorization", "Bearer " + token);
  req.setRequestHeader("Content-Type", "application/json");

  req.onload = () => {
    var data = req.response;
    var response;
    if (req.status !== 200) {
      if (req.status === 404) response = "404 Not Found";
      else response = JSON.parse(req.response.toString())["Message"] || "";
      setError(response);
      return;
    }
    var fileName = "Pain.xml";
    var file = new Blob([data], { type: "application/xml" });
    if (
      window.navigator.msSaveOrOpenBlob // IE10+
    )
      window.navigator.msSaveOrOpenBlob(file, fileName);
    else {
      // Others
      var link = document.createElement("a"),
        url = URL.createObjectURL(file);
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 0);
    }
  };
  req.send(
    JSON.stringify({
      WithdrawalOrderIds: result,
      Currency: currency,
    }),
  );
  setError("");
}
